import React, { useState, useEffect } from 'react';
import './styles/footer.css';
import logo from '../images/BPLogo.png';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaLinkedin, FaUserPlus, FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';

function Footer() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      window.location.href = '/';
    } catch (error) {
      console.error('Fejl ved logout:', error);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src={logo} alt="Byggeriets Partner Logo" className="footer-logo" />
            <p className="footer-tagline">
              Vi hjælper virksomheder med at optimere deres byggeprojekter gennem professionel kvalitetssikring og drift & vedligehold.
            </p>
            <img 
              src={require('../images/Børnetelefonen.jpg')} 
              alt="Børnetelefonen Logo" 
              className="footer-bornetelefonen"
            />
          </div>

          <div className="footer-links">
            <h4>Hurtige links</h4>
            <nav>
              <a href="/kvalitetssikring">Kvalitetssikring</a>
              <a href="/drift-og-vedligeholdelse">Drift & Vedligehold</a>
              <a href="/kursus">Kurser</a>
              <a href="/om">Om os</a>
              <a href="/kontakt">Kontakt</a>
            </nav>
          </div>

          <div className="footer-contact">
            <h4>Kontakt</h4>
            <div className="contact-info">
              <a href="tel:+4542411633">
                <FaPhone /> +45 42 41 16 33
              </a>
              <a href="mailto:info@byggerietspartner.dk">
                <FaEnvelope /> info@byggerietspartner.dk
              </a>
              <p>
                <FaMapMarkerAlt /> Centret 1, 4470 Svebølle
              </p>
              <p className="cvr">CVR: 28582056</p>
              {user && (
                <>
                  <button onClick={handleLogout} className="footer-logout-btn">
                    <FaSignOutAlt /> Log ud
                  </button>
                  <Link to="/registrer" className="footer-register-btn">
                    <FaUserPlus /> Registrer ny bruger
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-credit">Skabt af <a href="https://www.parlabranding.dk" target="_blank" rel="noopener noreferrer">Parla Branding</a></p>
          <div className="social-links">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
